import React from "react";
import { Link } from "react-router-dom";
import {
  Rocket,
  Lightbulb,
  Vote,
  GraduationCap,
  Trophy,
  CheckCircle2,
  Users,
  Target,
  Award,
  Medal,
  Plane,
  TrendingUp,
  ArrowRight,
} from "lucide-react";

import InnovationHubHeader from "../components/InnovationHubHeader";
import InnovationHubFooter from "../components/InnovationHubFooter";

export default function ITKStarterComingSoonPage() {
  const roadmap = [
    {
      icon: Lightbulb,
      title: "Fikir",
      text: "Fikir aşamasındaki girişim projeleriyle başvuru yapılır.",
    },
    {
      icon: Vote,
      title: "Değerlendirme",
      text: "Başvurular belirlenen değerlendirme kriterleri doğrultusunda incelenir.",
    },
    {
      icon: GraduationCap,
      title: "Eğitim ve Mentörlük",
      text: "Finale kalan ekipler eğitim ve mentörlük sürecine katılır.",
    },
    {
      icon: Rocket,
      title: "MVP",
      text: "Ekipler ürünlerinin ilk çalışan versiyonunu geliştirir.",
    },
    {
      icon: Trophy,
      title: "Final",
      text: "İTK'da yılın en iyi girişimleri açıklanır.",
    },
  ];

  const evaluationCriteria = [
    {
      no: 1,
      title: "İnovasyon ve Özgünlük Potansiyeli",
      weight: "%30",
      score1: "Bilinen bir projenin veya ürünün tekrarı.",
      score3:
        "Problem doğru tespit edilmiş. Çözüm, mevcut yöntemlere göre daha pratik bir yaklaşım içeriyor.",
      score5: "Tamamen yeni bir fikir.",
    },
    {
      no: 2,
      title: "Uygulanabilirlik (Ekip ve Gerçekçilik)",
      weight: "%30",
      score1:
        "Ekibin yetkinliği veya motivasyonu projeyi hayata geçirmek için yetersiz ya da belirsiz.",
      score3:
        "Fikrin nasıl üretileceğine dair yol haritası var. Ekip temel becerilere sahip veya öğrenmeye istekli.",
      score5: "Ekip projeyi yapabilecek yetkinlikte.",
    },
    {
      no: 3,
      title: "Ölçeklenebilirlik ve Etki Alanı",
      weight: "%30",
      score1: "Proje sadece küçük bir grubun işine yarar.",
      score3:
        "Proje okuldaki diğer öğrencilere veya farklı okullara da uyarlanabilir.",
      score5:
        "Doğru destekle hızla çok geniş kitlelere (ulusal/global) ulaşabilir.",
    },
    {
      no: 4,
      title: "Motivasyon ve Kuluçka İhtiyacı",
      weight: "%10",
      score1:
        "Programa neden başvurdukları ve merkezden ne bekledikleri net değil.",
      score3:
        "Ekip neye ihtiyacı olduğunu (mentörlük, atölye, yazılım desteği vb.) biliyor.",
      score5:
        "Kuluçka merkezinin imkanlarıyla projenin ihtiyaçları birebir örtüşüyor.",
    },
  ];

  const awards = [
    {
      icon: Medal,
      title: "Sertifika / Plaket",
      text: "Girişimcilik programını başarıyla tamamlayan katılımcılara sertifika ve plaket takdim edilecektir.",
    },
    {
      icon: Plane,
      title: "Girişimcilik Konferansı",
      text: "Öğrenci ve Çalışan kategorilerinde birinci olan ekiplere Slush benzeri prestijli bir girişimcilik konferansına katılım ödülü verilmesi planlanmaktadır.",
    },
    {
      icon: TrendingUp,
      title: "Yatırım Fırsatı",
      text: "Projenin ölçeğine göre belirlenecek şekilde, İTK Ventures'ın yatırım yapma ihtimali bulunmaktadır.",
    },
  ];

  return (
    <main
      className="relative min-h-screen overflow-hidden bg-gradient-to-b from-[#eef2f7] via-[#f4f7fb] to-[#e6ecf5]"
      style={{ fontFamily: "Poppins, sans-serif" }}
    >
      <div className="pointer-events-none absolute inset-0 opacity-[0.16] bg-[linear-gradient(90deg,rgba(21,101,192,0.05)_1px,transparent_1px),linear-gradient(rgba(21,101,192,0.05)_1px,transparent_1px)] bg-[size:42px_42px]" />

      <div className="relative z-10">
        <InnovationHubHeader />

        <section className="px-4 py-6 sm:px-5 md:px-6">
          <div className="mx-auto max-w-[1500px]">
            <div className="grid items-start gap-5 lg:grid-cols-[0.9fr_1.1fr]">
              {/* HERO LEFT */}
              <div className="rounded-[24px] bg-gradient-to-br from-[#1565C0]/10 via-white/95 to-[#C62828]/10 p-[1px] lg:rounded-[30px]">
                <div className="relative flex h-full flex-col overflow-hidden rounded-[23px] border border-white/70 bg-white/90 p-6 shadow-[0_20px_50px_rgba(21,101,192,0.10),0_8px_20px_rgba(0,0,0,0.04)] ring-1 ring-black/5 backdrop-blur-md lg:rounded-[29px] lg:p-8">
                  <div className="absolute -right-24 -top-24 h-64 w-64 rounded-full bg-[#1565C0]/6 blur-3xl" />
                  <div className="absolute -bottom-24 -left-20 h-56 w-56 rounded-full bg-[#C62828]/6 blur-3xl" />

                  <div className="relative z-10 mb-5 flex items-center gap-2">
                    <span className="h-[3px] w-[60px] rounded-full bg-[#1565C0]" />
                    <span className="h-[3px] w-[40px] rounded-full bg-[#C62828]" />
                  </div>

                  <div className="relative z-10">
                    <h1 className="tracking-[-0.04em]">
                      <span className="block text-3xl font-bold leading-tight text-[#173b7a] md:text-4xl">
                        Fikirden
                      </span>

                      <span className="block text-3xl font-bold leading-tight text-[#C62828] md:text-4xl">
                        Ürüne
                      </span>

                      <span className="mt-3 block text-2xl font-semibold leading-tight text-[#173b7a] md:text-3xl">
                        uzanan girişimcilik yolculuğu
                      </span>
                    </h1>

                    <p className="mt-6 max-w-2xl text-sm leading-8 text-slate-600 md:text-base">
                      İTK Starter; lise öğrencileri ve İTK çalışanlarının fikir
                      aşamasındaki girişim projelerini eğitim, mentörlük ve
                      değerlendirme süreçleriyle ürüne dönüştürmeleri için
                      tasarlanmış bir girişimcilik programıdır.
                    </p>
                    <p className="mt-6 max-w-2xl text-sm font-bold leading-8 text-slate-600 md:text-base">
                      Başvuru yapmadan önce mutlaka aşağıdaki değerlendirme kriterlerini okuyunuz.
                    </p>
                  </div>

                  <div className="relative z-10 mt-8 grid gap-3 sm:grid-cols-3">
                    <InfoPill icon={Users} text="Lise öğrencileri" />
                    <InfoPill icon={CheckCircle2} text="İTK çalışanları" />
                    <InfoPill icon={Lightbulb} text="Fikir aşaması" />
                  </div>

                </div>
              </div>

              {/* ROADMAP RIGHT */}
              <div className="rounded-[24px] bg-gradient-to-br from-[#1565C0]/10 via-white/95 to-[#C62828]/10 p-[1px] lg:rounded-[30px]">
                <div className="relative overflow-hidden rounded-[23px] border border-white/70 bg-white/90 p-6 shadow-[0_20px_50px_rgba(21,101,192,0.10),0_8px_20px_rgba(0,0,0,0.04)] ring-1 ring-black/5 backdrop-blur-md lg:rounded-[29px] lg:p-8">
                  <div className="absolute -right-20 top-10 h-48 w-48 rounded-full bg-[#1565C0]/6 blur-3xl" />
                  <div className="absolute -left-20 bottom-10 h-48 w-48 rounded-full bg-[#C62828]/6 blur-3xl" />

                  <div className="relative z-10 mb-7">
                    <p className="text-xs font-bold tracking-[0.22em] text-[#1565C0]">
                      Yol Haritası
                    </p>

                    <h2 className="mt-2 text-3xl tracking-[-0.03em] text-[#173b7a]">
                      İTK Starter Yolculuğu
                    </h2>

                    <p className="mt-3 max-w-2xl text-sm leading-7 text-slate-600">
                      Fikir aşamasından ürüne, oradan da yılın girişimlerine
                      uzanan yapılandırılmış gelişim süreci.
                    </p>
                  </div>

                  <div className="relative z-10">
                    <div className="absolute left-[23px] top-6 h-[calc(100%-48px)] w-[2px] bg-gradient-to-b from-[#1565C0]/30 via-[#C62828]/20 to-[#1565C0]/30" />

                    <div className="space-y-4">
                      {roadmap.map((item, index) => {
                        const Icon = item.icon;
                        const isRed = index % 2 === 1;

                        return (
                          <div
                            key={item.title}
                            className="relative grid grid-cols-[48px_1fr] gap-4"
                          >
                            <div
                              className={`z-10 flex h-12 w-12 items-center justify-center rounded-2xl shadow-lg ${
                                isRed
                                  ? "bg-[#C62828] text-white shadow-[#C62828]/20"
                                  : "bg-[#1565C0] text-white shadow-[#1565C0]/20"
                              }`}
                            >
                              <Icon size={21} />
                            </div>

                            <div className="rounded-2xl border border-white/80 bg-white/95 p-4 shadow-[0_8px_20px_rgba(21,101,192,0.06)] ring-1 ring-black/5 backdrop-blur transition hover:-translate-y-1 hover:shadow-[0_18px_35px_rgba(21,101,192,0.10)]">
                              <div className="flex items-center justify-between gap-3">
                                <h3
                                  className={`font-bold ${
                                    isRed
                                      ? "text-[#C62828]"
                                      : "text-[#1565C0]"
                                  }`}
                                >
                                  {item.title}
                                </h3>

                                <span className="shrink-0 rounded-full bg-[#eef5ff] px-3 py-1 text-[10px] font-bold text-[#173b7a]">
                                  {index + 1}. adım
                                </span>
                              </div>

                              <p className="mt-2 text-sm leading-6 text-slate-600">
                                {item.text}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* EVALUATION CRITERIA */}
            <section className="mt-5 rounded-[24px] bg-gradient-to-br from-[#1565C0]/10 via-white/95 to-[#C62828]/10 p-[1px] lg:rounded-[32px]">
              <div className="relative overflow-hidden rounded-[23px] border border-white/70 bg-white/90 p-5 shadow-[0_18px_40px_rgba(21,101,192,0.06)] ring-1 ring-black/5 backdrop-blur-md sm:p-6 lg:rounded-[31px] lg:p-8">
                <div className="absolute -right-16 -top-16 h-52 w-52 rounded-full bg-[#1565C0]/6 blur-3xl" />

                <div className="relative z-10 mb-7">
                  <div className="flex items-center gap-2">
                    <Target size={20} className="text-[#1565C0]" />

                    <p className="text-xs font-bold tracking-[0.22em] text-[#1565C0]">
                      DEĞERLENDİRME
                    </p>
                  </div>

                  <h2 className="mt-2 text-2xl font-bold tracking-[-0.03em] text-[#173b7a] md:text-3xl">
                    Değerlendirme Kriterleri
                  </h2>

                  <p className="mt-3 max-w-3xl text-sm leading-7 text-slate-600">
                    Başvurular dört temel kriter doğrultusunda değerlendirilir.
                    Her kriter 1, 3 veya 5 puan üzerinden puanlanır ve belirlenen
                    ağırlık oranıyla toplam değerlendirme skoruna dahil edilir.
                  </p>
                </div>

                {/* DESKTOP TABLE */}
                <div className="relative z-10 hidden overflow-hidden rounded-[20px] border border-slate-200 bg-white shadow-[0_12px_28px_rgba(21,101,192,0.07)] lg:block">
                  <div className="overflow-x-auto">
                    <table className="w-full table-fixed border-collapse">
                      <thead>
                        <tr className="bg-[#1565C0] text-white">
                          <th className="w-[5%] border-r border-white/20 px-3 py-4 text-center text-xs font-bold">
                            #
                          </th>

                          <th className="w-[19%] border-r border-white/20 px-4 py-4 text-left text-xs font-bold">
                            Değerlendirme Kriteri
                          </th>

                          <th className="w-[8%] border-r border-white/20 px-3 py-4 text-center text-xs font-bold">
                            Ağırlık
                          </th>

                          <th className="w-[22%] border-r border-white/20 px-4 py-4 text-left text-xs font-bold">
                            1 Puan
                          </th>

                          <th className="w-[23%] border-r border-white/20 px-4 py-4 text-left text-xs font-bold">
                            3 Puan
                          </th>

                          <th className="w-[23%] px-4 py-4 text-left text-xs font-bold">
                            5 Puan
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {evaluationCriteria.map((criterion, index) => (
                          <tr
                            key={criterion.no}
                            className={
                              index % 2 === 0 ? "bg-white" : "bg-[#f8fafc]"
                            }
                          >
                            <td className="border-r border-t border-slate-200 px-3 py-5 text-center align-top">
                              <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#1565C0] text-xs font-bold text-white">
                                {criterion.no}
                              </span>
                            </td>

                            <td className="border-r border-t border-slate-200 px-4 py-5 align-top">
                              <div className="text-sm font-bold leading-6 text-[#173b7a]">
                                {criterion.title}
                              </div>
                            </td>

                            <td className="border-r border-t border-slate-200 px-3 py-5 text-center align-top">
                              <span className="inline-flex rounded-full bg-[#C62828]/10 px-3 py-1 text-xs font-bold text-[#C62828]">
                                {criterion.weight}
                              </span>
                            </td>

                            <td className="border-r border-t border-slate-200 px-4 py-5 align-top text-xs leading-6 text-slate-600">
                              {criterion.score1}
                            </td>

                            <td className="border-r border-t border-slate-200 px-4 py-5 align-top text-xs leading-6 text-slate-600">
                              {criterion.score3}
                            </td>

                            <td className="border-t border-slate-200 px-4 py-5 align-top text-xs leading-6 text-slate-600">
                              {criterion.score5}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* MOBILE / TABLET */}
                <div className="relative z-10 space-y-4 lg:hidden">
                  {evaluationCriteria.map((criterion) => (
                    <div
                      key={criterion.no}
                      className="overflow-hidden rounded-[20px] border border-white/80 bg-white/95 shadow-[0_12px_28px_rgba(21,101,192,0.07)] ring-1 ring-black/5"
                    >
                      <div className="flex items-start justify-between gap-3 border-b border-slate-100 p-4 sm:p-5">
                        <div className="flex min-w-0 items-start gap-3">
                          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#1565C0] text-xs font-bold text-white">
                            {criterion.no}
                          </span>

                          <h3 className="text-sm font-bold leading-6 text-[#173b7a] sm:text-base">
                            {criterion.title}
                          </h3>
                        </div>

                        <span className="shrink-0 rounded-full bg-[#C62828]/10 px-3 py-1.5 text-xs font-bold text-[#C62828]">
                          {criterion.weight}
                        </span>
                      </div>

                      <div className="divide-y divide-slate-100">
                        <ScoreRow
                          score="1 Puan"
                          text={criterion.score1}
                        />

                        <ScoreRow
                          score="3 Puan"
                          text={criterion.score3}
                        />

                        <ScoreRow
                          score="5 Puan"
                          text={criterion.score5}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* AWARDS */}
            <section className="mt-5 rounded-[24px] bg-gradient-to-br from-[#1565C0]/10 via-white/95 to-[#C62828]/10 p-[1px] lg:rounded-[32px]">
              <div className="relative overflow-hidden rounded-[23px] border border-white/70 bg-white/90 p-5 shadow-[0_18px_40px_rgba(21,101,192,0.06)] ring-1 ring-black/5 backdrop-blur-md sm:p-6 lg:rounded-[31px] lg:p-8">
                <div className="absolute -left-20 -top-20 h-56 w-56 rounded-full bg-[#C62828]/6 blur-3xl" />
                <div className="absolute -bottom-20 -right-16 h-52 w-52 rounded-full bg-[#1565C0]/6 blur-3xl" />

                <div className="relative z-10 mb-7 text-center">
                  <Award size={32} className="mx-auto text-[#C62828]" />

                  <p className="mt-3 text-xs font-bold tracking-[0.22em] text-[#1565C0]">
                    ÖDÜLLER
                  </p>

                  <h2 className="mt-2 text-2xl font-bold tracking-[-0.03em] text-[#173b7a] md:text-3xl">
                    Fikrin Yolculuğu Ödülle Devam Ediyor
                  </h2>

                  <p className="mx-auto mt-3 max-w-3xl text-sm leading-7 text-slate-600">
                    İTK Starter, yalnızca proje geliştirme süreci değil;
                    katılımcıları girişimcilik ekosistemiyle buluşturan yeni
                    fırsatlar da sunmayı hedefler.
                  </p>
                </div>

                <div className="relative z-10 grid gap-4 md:grid-cols-3">
                  {awards.map((award, index) => {
                    const Icon = award.icon;
                    const isRed = index === 1;

                    return (
                      <div
                        key={award.title}
                        className="group rounded-[22px] border border-white/80 bg-white/95 p-5 shadow-[0_12px_28px_rgba(21,101,192,0.07)] ring-1 ring-black/5 transition duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(21,101,192,0.11)]"
                      >
                        <div
                          className={`flex h-12 w-12 items-center justify-center rounded-2xl text-white shadow-lg ${
                            isRed
                              ? "bg-[#C62828] shadow-[#C62828]/20"
                              : "bg-[#1565C0] shadow-[#1565C0]/20"
                          }`}
                        >
                          <Icon size={22} />
                        </div>

                        <h3
                          className={`mt-5 text-base font-bold ${
                            isRed ? "text-[#C62828]" : "text-[#173b7a]"
                          }`}
                        >
                          {award.title}
                        </h3>

                        <p className="mt-3 text-sm leading-7 text-slate-600">
                          {award.text}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>

            {/* CTA */}
            <section className="mt-5 rounded-[24px] bg-gradient-to-br from-[#1565C0]/10 via-white/95 to-[#C62828]/10 p-[1px] lg:rounded-[32px]">
              <div className="relative overflow-hidden rounded-[23px] border border-white/70 bg-white/90 p-6 text-center shadow-[0_18px_40px_rgba(21,101,192,0.06)] ring-1 ring-black/5 backdrop-blur-md lg:rounded-[31px] lg:p-8">
                <div className="absolute left-1/2 top-0 h-32 w-72 -translate-x-1/2 rounded-full bg-[#1565C0]/6 blur-3xl" />

                <Rocket
                  size={34}
                  className="relative z-10 mx-auto text-[#1565C0]"
                />

                <h2 className="relative z-10 mt-3 text-2xl font-bold tracking-[-0.03em] text-[#173b7a] md:text-3xl">
                  Fikrini İTK Starter'a Taşı
                </h2>

                <p className="relative z-10 mx-auto mt-3 max-w-2xl text-sm leading-7 text-slate-600">
                  Problemini tanımla, çözümünü anlat ve ekibinle birlikte
                  girişimcilik yolculuğuna ilk adımını at.
                </p>

                <Link
                  to="/starter-application"
                  className="relative z-10 mt-6 inline-flex w-full items-center justify-center gap-2 rounded-xl border border-[#1565C0] bg-[#1565C0] px-7 py-3.5 text-sm font-semibold text-white shadow-[0_8px_18px_rgba(21,101,192,0.16)] transition duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_28px_rgba(21,101,192,0.22)] sm:w-auto"
                >
                  Başvur
                  <ArrowRight size={18} />
                </Link>
              </div>
            </section>
          </div>
        </section>
      </div>

      <InnovationHubFooter />
    </main>
  );
}

function InfoPill({ icon: Icon, text }) {
  return (
    <div className="rounded-2xl border border-white/70 bg-white/70 p-3 shadow-sm backdrop-blur">
      <Icon size={18} className="mb-2 text-[#1565C0]" />
      <div className="text-xs font-bold text-[#173b7a]">{text}</div>
    </div>
  );
}

function ScoreRow({ score, text }) {
  return (
    <div className="grid grid-cols-[75px_1fr] gap-3 p-4 sm:grid-cols-[90px_1fr] sm:p-5">
      <div>
        <span className="inline-flex rounded-full bg-[#eef5ff] px-2.5 py-1 text-[10px] font-bold text-[#1565C0] sm:text-xs">
          {score}
        </span>
      </div>

      <p className="text-xs leading-6 text-slate-600 sm:text-sm">
        {text}
      </p>
    </div>
  );
}